module.exports = __webpack_public_path__ + "static/media/watchtoututoialb-banner.ec34747e.png";